import { Property, SaleType } from "src/app/models/property/property";
import { Achievement } from "../models/achievement/achievement";
import { Agent } from "../models/agent/agent";
import { Feature } from "../models/feature/feature";
import { Testimonial } from "../models/testimonial/testimonial";
export const PropertyByCities = [
    'Auburn Hills Property Management',
    'Berkley Property Management',
    'Beverly Hills Property Management',
    'Birmingham Property Management',
    'Bloomfield Hills Property Management',
    'Bloomfield Township Property Management',
    'Canton Property Management',
    'Center Line Property Management',
    'Chesterfield Property Management',
    'Clarkston Property Management',
    'Clinton Township Property Management',
    'Commerce Township Property Management',
    'Farmington Hills Property Management',
    'Fenton Property Management',
    'Franklin Property Management',
    'Fraser Property Management',
    'Grand Blanc Property Management',
    'Harper Woods Property Management',
    'Harrison Township Property Management',
    'Hazel Park Property Management',
    'Highland Township Property Management',
    'Holly Property Management',
    'Inkster Property Management',
    'Lake Orion Property Management',
    'Livonia Property Management',
    'Macomb Property Management',
    'Madison Heights Property Management',
    'Milford Property Management',
    'Northville Property Management',
    'Oak Park Property Management',
    'Plymouth Property Management',
    'Pontiac Property Management',
    'Royal Oak Property Management',
    'Troy Property Management',
    'Warren Property Management',
    'Waterford Property Management',
    'West Bloomfield Property Management',
    'White Lake Property Management',
];
export const PropertyMocks = [
    new Property(
        '1',
        new Date('2021-09-09').toISOString(),
        SaleType.ForRent,
        '23332 Clarewood Macomb',
        204900,
        '302, Seek Velly Canada',
        2,
        'Corporate',
        1244,
        2,
        'https://www.northbloomfield.com/img/main_images/small/3071588799654750208.JPG',
        'micheghan',
        'unit-200'
    ),
    new Property(
        '1',
        new Date('2021-09-09').toISOString(),
        SaleType.ForRent,
        '902 Chestnut Hill, unit C Auburn Hills',
        17540,
        '302, Seek Velly Canada',
        2,
        'Offices',
        857,
        1,
        'https://www.northbloomfield.com/img/main_images/small/991523175514169472.JPG',
        'micheghan',
        'unit-200'
    ),
    new Property(
        '1',
        new Date('2021-09-09').toISOString(),
        SaleType.ForRent,
        '23332 Clarewood Macomb',
        204900,
        '302, Seek Velly Canada',
        2,
        'Corporate',
        1244,
        2,
        'https://www.northbloomfield.com/img/main_images/small/3071588799654750208.JPG',
        'micheghan',
        'unit-200'
    ),
    new Property(
        '1',
        new Date('2021-09-09').toISOString(),
        SaleType.ForRent,
        '902 Chestnut Hill, unit C Auburn Hills',
        17540,
        '302, Seek Velly Canada',
        2,
        'Offices',
        857,
        1,
        'https://www.northbloomfield.com/img/main_images/small/991523175514169472.JPG',
        'micheghan',
        'unit-200'
    ),
    new Property(
        '1',
        new Date('2021-09-09').toISOString(),
        SaleType.ForRent,
        '23332 Clarewood Macomb',
        204900,
        '302, Seek Velly Canada',
        2,
        'Corporate',
        1244,
        2,
        'https://www.northbloomfield.com/img/main_images/small/3071588799654750208.JPG',
        'micheghan',
        'unit-200'
    ),
    new Property(
        '1',
        new Date('2021-09-09').toISOString(),
        SaleType.ForRent,
        '902 Chestnut Hill, unit C Auburn Hills',
        17540,
        '302, Seek Velly Canada',
        2,
        'Offices',
        857,
        1,
        'https://www.northbloomfield.com/img/main_images/small/991523175514169472.JPG',
        'micheghan',
        'unit-200'
    ),
    new Property(
        '1',
        new Date('2021-09-09').toISOString(),
        SaleType.ForRent,
        '23332 Clarewood Macomb',
        204900,
        '302, Seek Velly Canada',
        2,
        'Corporate',
        1244,
        2,
        'https://www.northbloomfield.com/img/main_images/small/3071588799654750208.JPG',
        'micheghan',
        'unit-200'
    ),
    new Property(
        '1',
        new Date('2021-09-09').toISOString(),
        SaleType.ForRent,
        '902 Chestnut Hill, unit C Auburn Hills',
        17540,
        '302, Seek Velly Canada',
        2,
        'Offices',
        857,
        1,
        'https://www.northbloomfield.com/img/main_images/small/991523175514169472.JPG',
        'micheghan',
        'unit-200'
    ),
];
export const AcheivementsMock = [
    new Achievement('967', 'Listings For Sale', 'tags'),
    new Achievement('1276', 'Listings For Rent', 'dollar-sign'),
    new Achievement('396', 'Our Agents', 'user'),
    new Achievement('30', 'Years of Excellence', 'medal'),
];
export const FeaturesMock: Feature[] = [
    new Feature('Free No Obligation Appointment For More Information', 'Click here to be contacted by one of our Rental Experts.', '/assets/img/free.png','applications/ContactUs'),
    new Feature('Pay Your Rent Online', 'We have moved our online payments site to a new secure location. Please visit our new secure payments site.', '/assets/img/pay.png','https://bloom.twa.rentmanager.com/'),
    new Feature('Apply Online', 'Take advantage of the convenience of applying online for properties you are interested in.', '/assets/img/online-apply.png','applications/ApplyOnline'),
];
export const TestimonialsMock: Testimonial[] = [
    new Testimonial(
        'Sher',
        `Rick C. and the staff members of NBP are always on time with requests, maintenance
        responses
        within hours, thank you for helping us find a house with all the amenities we
        wanted. Thanks for a
        job done just right and on time!`
    ),
    new Testimonial(
        'Alisha',
        `Awesome, thank you so much - these smooth process means so much to my family and I
        would
        definitely recommend your service! What are my next steps to move into our new home?`
    ),
    new Testimonial(
        'FL',
        `Would definatly recommend.`
    ),
    new Testimonial(
        'C.',
        `Thank you! I love your company!`
    ),
    new Testimonial(
        'DB',
        `Rick and Beth Pauwels were very professional and everybody at the Walton BLVD office
        were all
        great!`
    ),
    new Testimonial(
        'Anu',
        `My husband and I are very pleased with the quality of maintenance team and your
        professionalism.
        You are the strongest link of the organization. Thanks a lot! `
    ),
];
export const AgentsMock: Agent[] = [
    new Agent(
        'Colin H. Renda',
        '3599 Huntz Lane',
        4.5,
        'Dealer',
        'assets/img/user-1.jpg'
    ),
    new Agent(
        'James N. Green',
        '3940 Star Trek',
        4.7,
        'Agent',
        'assets/img/user-2.jpg'
    ),
    new Agent(
        'Colin H. Renda',
        '34 Marion Street',
        4.9,
        'Dealer',
        'assets/img/user-3.jpg'
    ),
    new Agent(
        'Litha N. Wreek',
        '1122 Flint Street',
        4.7,
        'Broker',
        'assets/img/user-8.jpg'
    ),
];
export const PropertyTypes = ['House', 'Commercial', 'Apartment', 'Duplex', 'Condo', 'Vacant Land', 'Multi-Unit'];
export const Cities = ['Los Angeles, CA', 'New York City, NY', 'Chicago, IL', 'Houston, TX', 'Philadelphia, PA', 'San Antonio, TX', 'San Jose, CA'];
export const Basements = ['No Basement', 'PVT', 'FIN', 'UNFIN', 'PTFIN', 'PFW/O', 'FIN WALKOUT', 'COMMON', 'YES'];
export const Garages = ['1', '1.3', '2', '2.5', '3', 'More than 3', 'Carport'];